var render, staticRenderFns
import script from "./AdminLicenseRegistryEntity.vue?vue&type=script&lang=js"
export * from "./AdminLicenseRegistryEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5356a45b')) {
      api.createRecord('5356a45b', component.options)
    } else {
      api.reload('5356a45b', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/AdminLicenseRegistryEntity.vue"
export default component.exports